"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerGetPaymentHistoryV1200Response = instanceOfSubscriptionsControllerGetPaymentHistoryV1200Response;
exports.SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSON = SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSON;
exports.SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSONTyped = SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSON = SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSON;
exports.SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSONTyped = SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSONTyped;
var PaymentHistoryItemDto_1 = require("./PaymentHistoryItemDto");
/**
 * Check if a given object implements the SubscriptionsControllerGetPaymentHistoryV1200Response interface.
 */
function instanceOfSubscriptionsControllerGetPaymentHistoryV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSON(json) {
    return SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerGetPaymentHistoryV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(PaymentHistoryItemDto_1.PaymentHistoryItemDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSON(json) {
    return SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerGetPaymentHistoryV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(PaymentHistoryItemDto_1.PaymentHistoryItemDtoToJSON)),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
